import React from 'react'
import { Link } from 'react-router-dom'

function Gifting() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>

        <div className="auto-container">
          <div className="inner">
            <h1>Gifting</h1>
            <div className="sub_text">
              <p>
                Home -{" "}
                <a href="#" className="primary-color">
                  Gifting
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box">
            <div className="subtitle">
              <span>Tickling Tummy</span>
            </div>

            <h2>
              <span className="theme_color">Festive Gifting </span> — Homemade
              Sweets, Bakes & Savories in Coimbatore
            </h2>
          </div>

          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                Celebrating a festival, special event, or corporate occasion?
                Tickling Tummy delivers homemade gift hampers filled with baked
                delights, traditional sweets, and savory treats—perfect for
                Diwali, Holi, New Year, anniversaries, weddings, or employee /
                client gifting.
                <br />
                <br />
                Our boxes include gulab jamun, malpua, vanilla cake, namkeens,
                cookies, and exclusive regional goodies—beautifully packaged and
                ready to delight.
              </p>

              <div className="title-box centered">
                <div className="subtitle">
                  <span>Why Choose Tickling Tummy Gifts?</span>
                </div>

                <div className="text">
                  <ul>
                    <li>
                      ◆ 100% homemade & preservative-free snacks, sweets, and
                      bakes
                    </li>
                    <li>
                      ◆ Curated for occasions: Diwali, Holi, New Year, Raksha
                      Bandhan, Eid, weddings, corporate gifting
                    </li>
                    <li>
                      ◆ Customizable quantities, box sizes, dietary options
                      (sugar-free, gluten-free)
                    </li>
                    <li>
                      ◆ Elegant packaging tailored for gifting loved ones or
                      business associates
                    </li>
                  </ul>
                </div>
              </div>

              <p>
                Each hamper is lovingly packed and ready to gift—with optional
                personalized notes and branded cards for corporate orders.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>

  );
}

export default Gifting
